import React from 'react';

export const DragIcon = ({ number }) => {
  const fontSize = number.length === 1 ? 12 : number.length === 2 ? 10 : 8; // Adjust font size based on number length
  return (
    <svg
      id="draggablecontainer-svg-icon"
      width="2.25rem"
      height="2.25rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3605_5624)">
        <circle
          id="draggablecontainer-circle-component"
          cx="15"
          cy="15"
          r="8"
          fill="white"
        />
        <path
          id="draggablecontainer-path-icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H9.1V5.25H14V6.05493C14.3283 6.01863 14.662 6 15 6C19.9706 6 24 10.0294 24 15C24 19.9706 19.9706 24 15 24C11.0813 24 7.74763 21.4956 6.51212 18H0V0ZM9.8 0.75V4.5H13.3L9.8 0.75ZM23 15C23 19.4183 19.4183 23 15 23C10.5817 23 7 19.4183 7 15C7 10.5817 10.5817 7 15 7C19.4183 7 23 10.5817 23 15Z"
          fill="#313131"
        />
        <text
          id={`draggablecontainer-text-${number}-icon`}
          x="15"
          y="15"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#313131"
          fontSize={fontSize}
        >
          {number}
        </text>
      </g>
      <defs>
        <clipPath id="clip0_3605_5624">
          <rect id="draggablecontainer-rect-clip" width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
